<form novalidate name="SearchEditForm" method="POST" id="SearchEditForm" class autocomplete="off" (ngSubmit)="SearchEditForm.valid && false" #SearchEditForm="ngForm">	<div class="input-group-sm">
		<input class="form-control"
			style="border-radius: 15px;"
			  type="text"
			  name="sitesearch"
			  required [(ngModel)]="searchString"
			  placeholder="Company Search..."
			  [resultTemplate]="rt"
			  (selectItem)="pickItem($event)"
			  [ngbTypeahead]="search" />
	</div>
	<ng-template #rt let-r="result" let-t="term">
		<ngb-highlight [result]="r.Text" [term]="t"></ngb-highlight>
	</ng-template>
</form>